<template>
<div class="phone-input-component">
  <input :id="id"
         type="tel"
         autocomplete="tel"
         class="form-control"
         @keyup.enter="$emit('submit')"
         :value="value"
         @input="window.setTimeout(() => $emit('input', $event.target.value))"
  >
</div>
</template>

<style lang="less">
.phone-input-component {
  &>.iti {
    width: 100%;
  }

  .iti--allow-dropdown {
    input[type=tel] {
      &.form-control {
        padding-right: 6px;
        padding-left: 52px;
        margin-left: 0;
      }
    }
  }
}
</style>

<script>
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/js/utils'
import { mapGetters } from 'vuex'

export default {
  $phoneInput: null,

  props: {
    value: {
      type: String,
    }
  },

  mounted() {
    this.country = this.countryCode
    this.$emit('input:country', this.country)

    const phoneInput = document.getElementById(this.id)

    this.$phoneInput = intlTelInput(phoneInput, {
      nationalMode: false,
      initialCountry: this.countryCode,
      preferredCountries: [this.countryCode],
      autoPlaceholder: 'aggressive',
    })

    phoneInput.addEventListener('countrychange', () => {
      const country = this.$phoneInput.getSelectedCountryData()

      if (!country || !country.iso2) {
        return
      }

      this.country = country.iso2.toString().toUpperCase()
      this.$emit('input:country', this.country)
    })
  },

  computed: {
    ...mapGetters({
      countryCode: 'store/countryCode',
    }),
  },

  data() {
    return {
      id: `phone-input-${Math.random().toString().replace('.', '')}`,
      country: '',
    }
  }
}
</script>
